
import { Component, Vue } from "vue-property-decorator";
import { VMoney } from "v-money";
import moment from "moment";
import "air-datepicker/dist/css/datepicker.min.css";

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {},
  computed: {},
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      return String(val).formatMoney();
    }
  },
  watch: {},
  directives: { money: VMoney }
})
export default class ModificarAsegurados extends Vue {
  paymentStatuses: any = ["Pendiente", "Aceptado", "Rechazado"];
  statuses: any = [];
  money: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: true
  };
  title: string = "Modificar Asegurados";
  claim: any = {};
  estimated_enabled: boolean = true;
  reserved_enabled: boolean = true;
  currencies: any = [];
  fields: any = {
    insurance_number: {
      value: "",
      label: "Número de Siniestro de la Cedente",
      toBeSaved: true
    },
    claim_date: { value: "", label: "Fecha del Siniestro", toBeSaved: false },
    status_client: { value: "", label: "Estado Cedente", toBeSaved: true },
    retainedsum_percent: {
      value: "",
      label: "Porcentaje Retenido",
      toBeSaved: false
    },
    aon_sum_percent: {
      value: "",
      label: "Porcentaje Cedido a AON",
      toBeSaved: false
    },
    estimated_indemnization: {
      value: "",
      label: "Estimado de Indemnización",
      toBeSaved: true
    },
    estimated_expenses: {
      value: "",
      label: "Estimado de Honorarios y Gastos",
      toBeSaved: true
    },
    estimated_total: {
      value: "",
      label: "Total estimado del Siniestro",
      toBeSaved: true
    },
    estimated_indemnization_aon: {
      value: "",
      label: "Estimado de Indemnización AON",
      toBeSaved: true
    },
    estimated_expenses_aon: {
      value: "",
      label: "Estimado de Honorarios y Gastos AON",
      toBeSaved: true
    },
    estimated_total_aon: {
      value: "",
      label: "Total estimado del Siniestro AON",
      toBeSaved: true
    },
    reserve_indemnization: {
      value: "",
      label: "Reserva de Indemnización",
      toBeSaved: true
    },
    reserve_expenses: {
      value: "",
      label: "Reserva de Honorarios y Gastos",
      toBeSaved: true
    },
    reserve_total: {
      value: "",
      label: "Total reserva del Siniestro",
      toBeSaved: true
    },
    reserve_indemnization_aon: {
      value: "",
      label: "Reserva de Indemnización AON",
      toBeSaved: true
    },
    reserve_expenses_aon: {
      value: "",
      label: "Reserva de Honorarios y Gastos AON",
      toBeSaved: true
    },
    reserve_total_aon: {
      value: "",
      label: "Total estimado del Siniestro AON",
      toBeSaved: true
    },
    claim_payment_amount: { value: "", label: "Monto Indemnizado" },
    claim_payment_amount_aon: { value: "", label: "Monto Indemnizado AON" },
    claim_payment_date: { value: "", label: "Fecha de Pago Indemnización" },
    claim_indemnization_expenses: {
      value: "",
      label: "Monto Honorarios y Gastos "
    },
    claim_indemnization_expenses_aon: {
      value: "",
      label: "Monto Honorarios y Gastos AON"
    },
    claim_payment_expenses_date: {
      value: "",
      label: "Fecha de pago Honorarios y Gastos"
    },
    claim_payment_type: {
      value: false,
      label: "Marcar Siniestro como Indemnizado"
    },
    currency_payment: {
      value: "",
      label: "Moneda de pago"
    }
  };
  async mounted() {
    await this.loadStatuses();
    await this.loadClaim();

    let _this = this;
    (this as any).$root.localizeDatepicker($);
    let datepicker = $("#claim_payment_date")
      .datepicker({
        language: "es",
        autoClose: true,
        onSelect: function onSelect(fd, date) {
          _this.fields.claim_payment_date.value = moment(date).format(
            "DD/MM/YYYY"
          );
        }
      })
      .data("datepicker");
    

    let datepicker2 = $("#claim_payment_expenses_date")
      .datepicker({
        language: "es",
        autoClose: true,
        onSelect: function onSelect(fd, date) {
          _this.fields.claim_payment_expenses_date.value = moment(date).format(
            "DD/MM/YYYY"
          );
        }
      })
      .data("datepicker");
  }
  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
    
  }
  async loadClaim() {
    const response: any = await (this.$root as any)._post(
      `claims/one/${this.$route.params.id}`,
      {
        models: "claims_payments"
      }
    );
    this.claim = response.data[0];
    let res = this.claim.claims_details[0];

    
    const currencySelector: any = await (this.$root as any)._get(
      `companiescurrencies/bycompany/${this.claim.request.companyId}`
    );

    

    currencySelector.data.forEach(row => {      
        this.currencies.push({
          id: row.currency.id,
          title: row.currency.title
        });       
    });
    

    let array = [
      "insurance_number",
      "status_client",
      "estimated_indemnization",
      "estimated_expenses",
      "estimated_total",
      "estimated_indemnization_aon",
      "estimated_expenses_aon",
      "estimated_total_aon",
      "reserve_indemnization",
      "reserve_expenses",
      "reserve_total",
      "reserve_indemnization_aon",
      "reserve_expenses_aon",
      "reserve_total_aon",
      "claim_payment_amount",
      "claim_payment_amount_aon",
      "claim_payment_date",
      "claim_indemnization_expenses",
      "claim_indemnization_expenses_aon",
      "claim_payment_expenses_date",
      "claim_payment_type"
    ];

    for (const key in this.fields) {
      if (array.indexOf(key) !== -1) {
        this.fields[key] = {
          ...this.fields[key],
          value: res[key],
          toBeSaved: true
        };
      } else {
        this.fields[key] = {
          ...this.fields[key],
          value: res[key],
          toBeSaved: false
        };
      }
    }

    this.fields.claim_date.value = response.data[0].claim_date;
    this.fields.status_client.value = response.data[0].status_client;
    this.fields.claim_payment_amount_aon.value = 0;
    this.fields.claim_indemnization_expenses_aon.value = 0;
  }

  settobesaved_reserve() {
    let array = [
      "reserve_indemnization",
      "reserve_expenses",
      "reserve_total",
      "reserve_indemnization_aon",
      "reserve_expenses_aon",
      "reserve_total_aon"
    ];

    (this as any).reserved_enabled = !(this as any).reserved_enabled;

    for (const key in this.fields) {
      if (array.indexOf(key) !== -1)
        this.fields[key].toBeSaved = !this.fields[key].toBeSaved;
    }
  }

  settobesaved_estimated() {
    let array = [
      "estimated_indemnization",
      "estimated_expenses",
      "estimated_total",
      "estimated_indemnization_aon",
      "estimated_expenses_aon",
      "estimated_total_aon"
    ];

    (this as any).estimated_enabled = !(this as any).estimated_enabled;

    for (let key in this.fields) {
      if (array.indexOf(key) !== -1)
        this.fields[key].toBeSaved = !this.fields[key].toBeSaved;
    }
  }

  calculateEstimated() {
    let retainedsum_percent = this.fields.retainedsum_percent.value;
    let estimated_indemnization = parseFloat(
      String(this.fields.estimated_indemnization.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );
    let estimated_expenses = parseFloat(
      String(this.fields.estimated_expenses.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );

    this.fields.estimated_indemnization_aon.value =
      estimated_indemnization -
      (estimated_indemnization / 100) * retainedsum_percent;
    this.fields.estimated_expenses_aon.value =
      estimated_expenses - (estimated_expenses / 100) * retainedsum_percent;

    this.fields.estimated_total.value =
      estimated_indemnization + estimated_expenses;
    this.fields.estimated_total_aon.value =
      this.fields.estimated_expenses_aon.value +
      this.fields.estimated_expenses_aon.value;
  }

  calculateReserve() {
    let retainedsum_percent = this.fields.retainedsum_percent.value;
    let reserve_indemnization = parseFloat(
      String(this.fields.reserve_indemnization.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );
    let reserve_expenses = parseFloat(
      String(this.fields.reserve_expenses.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );

    this.fields.reserve_indemnization_aon.value =
      reserve_indemnization -
      (reserve_indemnization / 100) * retainedsum_percent;
    this.fields.reserve_expenses_aon.value =
      reserve_expenses - (reserve_expenses / 100) * retainedsum_percent;

    this.fields.reserve_total.value = reserve_indemnization + reserve_expenses;
    this.fields.reserve_total_aon.value =
      this.fields.reserve_indemnization_aon.value +
      this.fields.reserve_expenses_aon.value;
  }

  calculatePaymentAmount() {
    let aon_sum_percent = this.fields.aon_sum_percent.value;


    let claim_payment_amount = parseFloat(
      String(this.fields.claim_payment_amount.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );
    let claim_indemnization_expenses = parseFloat(
      String(this.fields.claim_indemnization_expenses.value)
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );

    this.fields.claim_payment_amount_aon.value =
     ((claim_payment_amount / 100) * aon_sum_percent);
    this.fields.claim_indemnization_expenses_aon.value =
      (claim_indemnization_expenses / 100) * aon_sum_percent;     
   
  }

  async save() {
    try {
      let payload = {
        estimated_indemnization: 0,
        estimated_expenses: 0,
        estimated_total: 0,
        estimated_indemnization_aon: 0,
        estimated_expenses_aon: 0,
        estimated_total_aon: 0,
        reserve_indemnization: 0,
        reserve_expenses: 0,
        reserve_total: 0,
        reserve_indemnization_aon: 0,
        reserve_expenses_aon: 0,
        reserve_total_aon: 0
      };

      Object.keys(payload).forEach(key => {
        if (this.fields[key] && this.fields[key].toBeSaved) {
          payload[key] = parseFloat(
            String(this.fields[key].value)
              .replace(/\./g, "")
              .replace(/,/g, ".")
          );
        } else {
          delete payload[key];
        }
      });

      payload["insurance_number"] = this.fields["insurance_number"].value;
      payload["status_client"] = this.fields["status_client"].value;
      let payment_amount = parseFloat(
        String(this.claim.claims_details[0].payment_amount)
          .replace(/\./g, "")
          .replace(/,/g, ".")
      );
      payload["total_paid_precision"] =
        (payload["estimated_total"] /
          (payment_amount == 0 ? 1 : payment_amount)) *
        100;

      const response: any = await (this.$root as any)._put(
        `claims/${this.$route.params.id}`,
        payload
      );
      if (response.error) {
        (this.$root as any).notify(response.error, "error");
      } else {
        (this.$root as any).notify(
          "Los datos se guardaron con éxito",
          "success"
        );
        setTimeout(() => {
          this.$router.push("/claims/process-claims");
        }, 2000);
      }
    } catch (e) {
      console.log(e);
      (this.$root as any).notify(
        "No se pudo modificar los asegurados.",
        "error"
      );
    }
  }

  async savePayment() {
    try {
      let payload: any = {
        payment_amount: 0,
        payment_amount_aon: 0,
        indemnization_expenses: 0,
        indemnization_expenses_aon: 0
      };


       Object.keys(payload).forEach(key => {
         let payloadValues = String(this.fields["claim_" + key].value)
         payload[key] = payloadValues.includes(",") ? parseFloat(payloadValues.replace(/\./g, "").replace(/,/g, ".")) : parseFloat(payloadValues);    
       });        
    

      payload.isReclaim = false;
      payload.claimId = this.$route.params.id;
      payload.reclaim_amount = 0;
      payload.reclaim_amount_aon = 0;
      payload.reclaim_date = null;
      payload.payment_date = moment(
        this.fields["claim_payment_date"].value,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      payload.payment_expenses_date = moment(
        this.fields["claim_payment_expenses_date"].value,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      payload.type = this.fields["claim_payment_type"].value !== undefined ? this.fields["claim_payment_type"].value : false;
      payload.expenses_amount = payload.indemnization_expenses;
      payload.expenses_amount_aon = payload.indemnization_expenses_aon;
      payload.currencyId = this.fields.currency_payment;

      const response: any = await (this.$root as any)._post(
        `claimspayments`,
        payload
      );
      if (response.error) {
        (this.$root as any).notify(response.error, "error");
      } else {
        (this.$root as any).notify("El pago se guardó con éxito", "success");
        this.loadClaim();
      }
    } catch (e) {
      console.log(e);
      (this.$root as any).notify("No se pudo guardar el pago", "error");
    }
  }

  statusClass(status) {
    if (status === 1) return "active";
    if (status === 0) return "pending";
    return "inactive";
  }
}
